import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "my-1 flex flex-wrap justify-between" }
const _hoisted_2 = { class: "lg:w-1/2 w-full" }
const _hoisted_3 = { class: "lg:w-1/2 w-full text-right" }

import FullButton from '@/components/Buttons/FullButton.vue'
    import TextButton from '@/components/Buttons/TextButton.vue'
    import useContactStore from '@/utils/useContactStore'
    import router from '@/router'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'TheContactsNavigation',
  setup(__props) {

    const { selectedContact } = useContactStore()

    function createNewContact() {
        selectedContact.value = {}
        selectedContact.value.person = {}
        selectedContact.value.organisation = {}
        selectedContact.value.billing = {}

        router.push('/contacts/edit/0')
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TextButton, {
      title: "Adressbuch",
      link: "/contacts",
      id: "contacts-subnavigationTitle"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(FullButton, {
          title: "Neuen Kontakt erfassen",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (createNewContact())),
          width: "95",
          colour: "red",
          id: "contacts-subnavigationButton1"
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(FullButton, {
          title: "Erweiterte Suche",
          link: "/contacts/search",
          width: "95",
          colour: "red",
          id: "contacts-subnavigationButton2"
        })
      ])
    ])
  ], 64))
}
}

})